export default __webpack_public_path__ + "static/media/photo-button.8c014500.svg";